const size_fixed_h = (height: string) => `
    height    : ${height};
    max-height: ${height};
    min-height: ${height};
`;

const size_fixed_w = (width: string) => `
    width    : ${width};
    max-width: ${width};
    min-width: ${width};
`;

const size_fixed = (height: string, width: string = height) => `
    ${size_fixed_h(height)}
    ${size_fixed_w(width)}
`;

export { size_fixed_h, size_fixed_w, size_fixed };
